module.exports = __webpack_public_path__ + "img/logoSetting.82adaa2c.svg";